import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["teamUrls"]

  updateTeam(event) {
    const teamId = event.target.value
    if (!teamId) return

    const urls = JSON.parse(this.teamUrlsTarget.textContent)
    const url = urls[teamId]

    if (url) {
      window.location = url
    }
  }
}
